import { styled } from '@mui/material/styles';
import { 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogContentText, 
  DialogTitle,
  Typography
 } from '@mui/material';

export const ModalContainer = styled(Dialog)(({ theme }) => ({
  fontFamily: theme.fonts.default,

  "@media (max-width: 600px)": {
    width: '100%',
  },

  '.MuiPaper-root': {
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,

    borderRadius: "1rem",
    boxShadow: '0px 16px 64px 0px #000',

    fontFamily: theme.fonts.default,
    backgroundColor: theme.colors['neutral.900'],
    padding: '3rem',
    margin: 0,

    "@media (max-width: 600px)": {
      maxWidth: '90%',
      padding: theme.space._500,
    },
  },
}));

export const ModalHeader = styled(DialogTitle)(({ theme }) => ({
  textAlign: 'center',
  letterSpacing: '0em',
  lineHeight: theme.lineHeights.slim,

  fontSize: theme.fontSizes['3xl'],
  fontWeight: theme.fontWeights.bold,

  padding: 0,
    
  backgroundColor: theme.colors['neutral.900'],
  color: theme.colors['neutral.50'],

  "@media (max-width: 600px)": {
    fontSize: theme.fontSizes['2xl'],
    textAlign: 'left',
  },
}));

export const ModalContentWrapper = styled(DialogContent)(({theme}) => ({
  backgroundColor: theme.colors['neutral.900'],
  position: "relative",
  padding: 0,
  flexDirection: "column",
  gap:  theme.space._600,

  "&.scrollable::after" : {
    content: "''",
    position: 'absolute',
    left: 0,
    bottom: 0,
    width: '100%',
    height: "5.125rem;", 
    background: 'linear-gradient(180deg, rgba(33, 33, 33, 0.00) 0%, #212121 100%)',
    zIndex: 1,
    pointerEvents: "none",
  },

  "@media (max-width: 600px)": {
    gap:  theme.space._400,
  }
}));

export const ModalBody = styled(DialogContentText)(({ theme }) => ({
  padding: 0,
  color: theme.colors['neutral.500'],
  fontWeight: theme.fontWeights.regular,  
  fontSize: theme.fontSizes.md,
}));

export const ModalActionContainer = styled(DialogActions)(({ theme }) => ({
    backgroundColor: theme.colors['neutral.900'],
    padding: 0,
    display: 'flex',
    justifyContent: "flex-end",
    
    "&.justify-between": {
      justifyContent: "space-between",
    },
  }),
);

export const StyledForm = styled("form")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  gap: theme.space._650,
  overflowY: "auto",
  maxHeight: "65vh",
  paddingBottom: theme.space._700,
  
  "@media (max-width: 600px)": {
    maxHeight: "55vh",
    gap:  theme.space._600,
  }
}));

export const TicketHolderContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignSelf: "stretch",
  minHeight: theme.space._800,
  alignItems: "center",
  gap: theme.space._300,
  borderBottom: `1px solid ${theme.colors['neutral.950']}`,
  flexWrap: 'wrap',
  padding: `${theme.space._400} 0 `,
}));

export const TicketRemovalContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignSelf: "stretch",
  flexDirection: "column"
}));

export const TicketHolder = styled(Typography)(({ theme }) => ({
  color: theme.colors["neutral.50"],
  fontFamily: theme.fonts.default,
  fontSize: theme.fontSizes.sm,
  fontStyle: 'normal',
  fontWeight: theme.fontWeights.semibold,
  lineHeight: theme.lineHeights.base,
  flex: 5,
}));

export const ActionsContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignSelf: "stretch",
  justifyContent: "flex-end",
  paddingLeft: theme.space._200,

  "@media (max-width: 600px)": {
    paddingLeft: 0,
  },
}));

export const BadgesContainer = styled("div")(({ theme }) => ({
  display: "flex",
  justifyContent: "flex-end",
  gap: theme.space._200,
}));
